 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML01_HALF_TIT from '@/components/html/01_Half_Tit'
 import HTML02_SERIES from '@/components/html/02_Series'
 import HTML03_TITLE from '@/components/html/03_Title'
 import HTML04_COPYRIGH from '@/components/html/04_Copyrigh'
 import HTML05_DEDICATI from '@/components/html/05_Dedicati'
 import HTML06_CONTENTS from '@/components/html/06_Contents'
 import HTML07_HALF_TIT from '@/components/html/07_Half_Tit'
 import HTML08_INTRODUC from '@/components/html/08_Introduc'
 import HTML09_1__HOW_F from '@/components/html/09_1__How_F'
 import HTML10_2__READI from '@/components/html/10_2__Readi'
 import HTML11_3__SOUTH from '@/components/html/11_3__South'
 import HTML12_4__CORVE from '@/components/html/12_4__Corve'
 import HTML13_5__FROM from '@/components/html/13_5__From'
 import HTML14_6__WHO_Y from '@/components/html/14_6__Who_Y'
 import HTML15_7__HONKY from '@/components/html/15_7__Honky'
 import HTML16_8___IT_S from '@/components/html/16_8___It_s'
 import HTML17_9__HILLB from '@/components/html/17_9__Hillb'
 import HTML18_10__STRE from '@/components/html/18_10__Stre'
 import HTML19_11__BONU from '@/components/html/19_11__Bonu'
 import HTML20_12___WEL from '@/components/html/20_12___Wel'
 import HTML21_13__WILD from '@/components/html/21_13__Wild'
 import HTML22_14__GONE from '@/components/html/22_14__Gone'
 import HTML23_15__ACT from '@/components/html/23_15__Act'
 import HTML24_16__THE from '@/components/html/24_16__The'
 import HTML25_17__PLAY from '@/components/html/25_17__Play'
 import HTML26_18__SOUT from '@/components/html/26_18__Sout'
 import HTML27_19__SPLI from '@/components/html/27_19__Spli'
 import HTML28_20__PROD from '@/components/html/28_20__Prod'
 import HTML29_21__THE from '@/components/html/29_21__The'
 import HTML30_22___I_W from '@/components/html/30_22___I_W'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML31_APPENDIX from '@/components/html/31_Appendix'
 import HTML32_ACKNOWLE from '@/components/html/32_Acknowle'
 import HTML33_IMG from '@/components/html/33_Img'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/06_Contents",
 			"name" : "html/06_Contents",
 			"component" : HTML06_CONTENTS
 		},
 		{
 			"path" : "/html/07_Half_Tit",
 			"name" : "html/07_Half_Tit",
 			"component" : HTML07_HALF_TIT
 		},
 		{
 			"path" : "/html/08_Introduc",
 			"name" : "html/08_Introduc",
 			"component" : HTML08_INTRODUC
 		},
 		{
 			"path" : "/html/09_1__How_F",
 			"name" : "html/09_1__How_F",
 			"component" : HTML09_1__HOW_F
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js